import React, {useEffect, useRef, useState} from "react"
import styled from "styled-components"
import _ from "lodash"

import automationService from "data/automation"
import CarouselAutomation from "components/carousel-automation"
import BasicModal from "components/modal/basic-modal"
import { Button_s } from "styles/app-styles"
import loadingService from 'data/loading'

const AUTOMATION_CLASS = 'automated'

const NewPropFormContainer = styled.div`
  input {
    width: 60px;
  }
  button {
    margin-left: 20px;
  }
`

type DuplicateModalProps = {
  show: boolean
  close: () => void
  copy: (number) => void
  title: string
}

export const DuplicateModal = (props: DuplicateModalProps) => {
  const buttonRef = useRef<any>()
  const inputRef = useRef<any>()
  const [inputFocused, setInputFocused] = useState(false)

  useEffect(() => {
    if (!props.show) {
      setInputFocused(false)
      inputRef.current.value = ''
      automationService.broadcast("MODAL_CLOSING", {})
    }
    else if (!inputFocused && inputRef.current) {
      inputRef.current.focus()
      setInputFocused(true)
    }

  }, [props.show])

  const keyDown = (e) => {
    if (e.key == 'Tab') {
      // toggle focus
      // if (e.target === buttonRef.current) inputRef.current.focus()
      // else buttonRef.current.focus()
    } else if (e.key == 'Enter') {
      props.copy(+inputRef.current.value || 1)
      close()
    } else if (e.key == 'Escape') {
      close()
    }
  }

  const enforceBounds = (e) => {
    let value = e.target.value
    if (value === '') return // allow blanking input to change leading digit
    if (value < 1) value = 1
    if (value > 100) value = 100
    e.target.value = value
  }

  const close = () => {
    automationService.broadcast("MODAL_CLOSING", {})
    props.close()
  }

  const copy = async () => {
    loadingService.toggleLoading(true, 'copy');
    await props.copy(+inputRef.current.value || 1)
    loadingService.toggleLoading(false, 'copy');
    close()
  }

  let automation_class = props.show ? AUTOMATION_CLASS : ''

  return (
    <BasicModal
      width={255}
      show={props.show}
      toggleShow={() => { props.close() }}
      title={`How Many ${props.title} Duplicates?`}>
        <NewPropFormContainer id={'duplicate-modal'}>
          Count <input className={automation_class} type="number" min="1" max="100" onKeyDown={keyDown} onChange={enforceBounds} ref={inputRef} defaultValue={"1"}></input>
          <Button_s className={automation_class} onKeyDown={keyDown} ref={buttonRef} onClick={copy}>Duplicate</Button_s>
        </NewPropFormContainer>
        <CarouselAutomation outsideTable={true}/>
    </BasicModal>
  )
}
